import { FC } from 'react';
import { useParams } from 'react-router-dom';
import styled from 'styled-components';
import useSWR from 'swr';
import { PageBack, PageHeadContainer, PageTitle } from 'components/PageHead';
import User from 'types/User';
import Associate from './Associate';

const Title = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-bottom: 0.5rem;
`;

const Name = styled.p`
  color: var(--gray-500);
  font-size: 0.9rem;
  margin-left: calc(8px + 1.5rem);
`;

const AssociatePage: FC = () => {
  const { id } = useParams();

  const mentee: User | undefined = useSWR(`/user/${id}`).data;

  return (
    <>
      <PageHeadContainer>
        <PageTitle>
          <div>
            <Title>
              <PageBack href={`/admin/mentoring/mentees/${mentee?.id}/`} />
              <h1>Créer un nouveau mentorat</h1>
            </Title>
            <Name> {mentee?.firstName + ' ' + mentee?.lastName} </Name>
          </div>
        </PageTitle>
      </PageHeadContainer>
      <Associate />
    </>
  );
};

export default AssociatePage;
